// Standard copy
import SUMMARY_COPY from './summary/copy';
import DETAILS_COPY from './details/copy';

// Common Overrides
import COMMON_TOOLTIP_COPY from './tooltipCopy';

// Details Overrides
import DETAILS_TOOLTIP_COPY from './details/tooltipCopyOverrides';

// Experiment Overrides
import EXPERIMENT_SUMMARY_COPY from './summary/experimentCopy';
import EXPERIMENT_DETAILS_COPY from './details/experimentCopy';
import EXPERIMENT_TOOLTIP_COPY from './experimentTooltipCopy';

export const NOT_APPLICABLE = 'N/A'; // see src/app/pages/Pricing/lib/packageFeatures/details/tooltipCopy.ts

export const SUMMARY_MERGED_COPY = Object.freeze({
  ...COMMON_TOOLTIP_COPY,
  ...SUMMARY_COPY,
  ...EXPERIMENT_SUMMARY_COPY,
  ...EXPERIMENT_TOOLTIP_COPY,
});
export const DETAILS_MERGED_COPY = Object.freeze({
  ...COMMON_TOOLTIP_COPY,
  ...DETAILS_TOOLTIP_COPY,
  ...DETAILS_COPY,
  ...EXPERIMENT_DETAILS_COPY,
  ...EXPERIMENT_TOOLTIP_COPY,
});
